<div class="app-container">
  <p-toast position="top-right" />
  <app-update-notification />

  @if ((appLoadingService.loading$ | async) !== true) {
    <dk-notification-toast />
    <router-outlet />
    <dk-cookie-consent />
  } @else {
    <div class="loading-container">
      <img src="assets/favicon.png" alt="" class="loading-favicon" aria-hidden="true" />
    </div>
  }
</div>
